import React from "react";
import { Link } from "react-router-dom";
import Sidebar, { MobileHeader } from "./Sidebar";

// Shared dark-theme wrapper for the legal/info pages (FAQ, Terms, Privacy) so
// they match the site theme and share the left rail for navigation.
export default function LegalShell({ title, subtitle, children }) {
  return (
    <div className="relative min-h-screen bg-black text-white">
      <Sidebar />

      <div className="min-h-screen md:pl-60">
        <MobileHeader />

        <section className="px-4 pb-8 pt-10 sm:pt-16">
          <div className="mx-auto max-w-4xl text-center">
            <h1 className="bg-gradient-to-r from-yellow-400 to-amber-500 bg-clip-text text-4xl font-bold text-transparent sm:text-5xl">
              {title}
            </h1>
            <div className="mx-auto mt-3 h-1 w-40 rounded-full bg-gradient-to-r from-yellow-400 to-amber-500" />
            {subtitle ? (
              <p className="mt-4 text-sm text-white/50">{subtitle}</p>
            ) : null}
          </div>
        </section>

        <main className="px-4 pb-24">
          <div className="mx-auto max-w-4xl">{children}</div>
        </main>

        <footer className="border-t border-white/10 px-4 py-8 text-center text-sm text-white/40">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <Link to="/terms" className="hover:text-white/70">
              Terms
            </Link>
            <Link to="/privacy" className="hover:text-white/70">
              Privacy
            </Link>
            <Link to="/faq" className="hover:text-white/70">
              FAQ
            </Link>
            <Link to="/updates" className="hover:text-white/70">
              Patch updates
            </Link>
            <Link to="/support" className="hover:text-white/70">
              Support
            </Link>
          </div>
          <p className="mt-3">© 2026 Pagent. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}
